/* External */
import {
  memo,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Components */
import Confirmation from '../../../components/Confirmation/Confirmation';

/* Services */
import { gaService } from '../../../services/gaService';

/* Utils */
import { noOp } from '../../../utils/functions';
import { REPORT_GA } from '../../../utils/constants';
import { redirectTo } from '../../../utils/history';
import { getPath, Routes } from '../../../utils/router';
import { GTM_EVENT_NAMES, GTM_SUBCATEGORIES } from '../../../utils/googleTags';

function SignOffConfirmation({ onCancelPress, settingsCommonTagEvent }) {
  const handleCancelPress = useCallback(() => {
    onCancelPress();

    gaService.sendEvent({
      action: REPORT_GA.GA_EVENT_ACTION_IGNORE,
      label: REPORT_GA.GA_EVENT_LABEL_NA,
      category: REPORT_GA.GA_EVENT_CATEGORY_LOGOUT,
    });
  }, [onCancelPress]);

  const onAcceptPress = useCallback(() => {
    settingsCommonTagEvent({
      subCategory: GTM_SUBCATEGORIES.SETTINGS.LOG_OUT_CONFIRMATION,
      eventName: GTM_EVENT_NAMES.SETTINGS.CONFIRM,
    });
    redirectTo(getPath(Routes.Logout));
  }, [settingsCommonTagEvent]);

  return (
    <Confirmation
      messageTranslationId="settings.confirmation.message"
      acceptTranslationId="common.accept"
      cancelTranslationId="common.ignore"
      onAcceptPress={onAcceptPress}
      onCancelPress={handleCancelPress}
    />
  );
}

SignOffConfirmation.defaultProps = {
  onCancelPress: noOp,
  settingsCommonTagEvent: noOp,
};

SignOffConfirmation.propTypes = {
  onCancelPress: PropTypes.func,
  settingsCommonTagEvent: PropTypes.func,
};

export default memo(withFocusable()(memo(SignOffConfirmation)));
